<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Meine Fristen<v-spacer></v-spacer>
        <v-btn
          text
          outlined
          small
          class="mr-2"
          :to="{
            name: 'member-management-personnel-records-details-deadlines',
            params: {
              organizationId: $route.params.organizationId,
              itemId: currentUserUid,
            },
          }"
          >Details anzeigen</v-btn
        >
      </v-card-title>

      <div>
        <personnel-record-deadlines-data-list
          hideHeader
          :deadlineEntries="deadlinesCacheWithStatus.entries"
          :show-update-button="false"
          :loading="helpers.dataIsLoading"
        >
        </personnel-record-deadlines-data-list>
      </div>
    </v-card>
  </div>
</template>

<script>
import { db, auth } from "@/firebase";
import PersonnelRecordDeadlinesDataList from "@/components/member-management/personnel-records/PersonnelRecordDeadlinesDataList.vue";
export default {
  name: "self-service-deadlines",
  components: {
    PersonnelRecordDeadlinesDataList,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: true,
      },
      deadlinesCache: {
        entries: [],
      },
      currentUserUid: auth.currentUser.uid,
      unsubscribe: null,
    };
  },
  computed: {
    deadlinesCacheWithStatus() {
      return {
        ...this.deadlinesCache,
        entries: this.deadlinesCache.entries.map((entry) => {
          const dueDate =
            entry.dueDate && typeof entry.dueDate.toDate === "function"
              ? entry.dueDate.toDate()
              : new Date(entry.dueDate);
          const today = new Date();
          // Zero out the time for accurate day comparison
          dueDate.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          const diffTime = dueDate - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays < 0) {
            return {
              ...entry,
              status: "expired",
            };
          } else if (diffDays >= 0 && diffDays <= 30) {
            return {
              ...entry,
              status: "soonDue",
            };
          } else {
            return {
              ...entry,
              status: "valid",
            };
          }
        }),
      };
    },
  },
  created() {
    this.initialize();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    initialize() {
      this.helpers.dataIsLoading = true;
      this.getPersonalDeadlineEntriesCache();
    },
    getPersonalDeadlineEntriesCache() {
      const docRef = db
        .collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("deadlinesCache")
        .doc(this.currentUserUid);

      this.unsubscribe = docRef.onSnapshot(
        (doc) => {
          if (doc.exists) {
            this.deadlinesCache = doc.data();
          } else {
            this.deadlinesCache = { entries: [] };
          }
          this.helpers.dataIsLoading = false;
        },
        (error) => {
          console.log("Error getting document:", error);
          this.helpers.dataIsLoading = false;
        }
      );
    },
    timestampConverter(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
